export default [
    {
      path: '/admin/inventory/product-packaging',
      name: 'product-packaging',
      meta: { requiresAuth: true },
      component: () => import('@/pages/inventory/product-packaging/index.vue')
    }
  ]
